import { Grid, GridItem } from '@chakra-ui/react'
import { teamMembers } from './team-members'
import { TeamGalleryCard } from './team-gallery-card'
import { neueMachina } from '../../../../../../fonts'

export const TeamGallery = () => {
  return (
    <Grid
      w="full"
      templateColumns="repeat(auto-fill,minmax(0,25rem))"
      justifyContent="center"
      gap="1rem"
      fontFamily={neueMachina.style.fontFamily}
    >
      {teamMembers.map((member) => {
        return (
          <GridItem key={member.name} h="45rem" maxW="full">
            <TeamGalleryCard teamMember={member} />
          </GridItem>
        )
      })}
    </Grid>
  )
}
